export default class CommandsController {
  _requestService;
  _paths;

  constructor(requestService, paths) {
    this._requestService = requestService;
    this._paths = paths;
  }

  dataToShareChild(infoToShareCHild) {
    const { assignToParentId, childList, assign, canEdit } = infoToShareCHild;

    return {
      parent_to_assign: assignToParentId,
      children: childList,
      assign,
      parent_can_edit: canEdit,
    };
  }
  dataToInviteParent(infoToShareCHild) {
    const { email, name, lastName, assignToParentId, childList, canEdit } = infoToShareCHild;

    return {
      email,
      name,
      last_name: lastName,
      parent_who_invites: assignToParentId,
      children_to_assign: childList,
      parent_can_edit: canEdit,
    };
  }

  async setSessionRequest({ route, device }) {
    let params = {
      route: route,
      device: device,
    };
    return new Promise((resolve, reject) => {
      this._requestService
        .Post(this._paths.SESSION_PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async sentComment({ user_id, email, message, is_child }) {
    try {
      const path = this._paths.ABOUT_COMMENT;
      const { data } = await this._requestService.Post(path, { user_id, email, message, is_child });
      return data;
    } catch (error) {
      throw new Error(error);
    }
  }

  async settingSentNitficationSetup({ isParent, userId, payload }) {
    const path = this._paths.SETTINGS_UPDATE_CONFIGURATION(isParent, userId);
    const { data } = await this._requestService.Patch(path, payload);
    return data;
  }

  async settingsUpdateTimeZone({ isParent, userId, payload }) {
    const path = this._paths.SETTINGS_GET_TIMEZONE_SETUP(isParent, userId);
    const { data } = await this._requestService.Post(path, payload);
    return data;
  }

  async setParentAssignChildren(infoToShareCHild) {
    try {
      const body = this.dataToShareChild(infoToShareCHild);
      const path = this._paths.PARENT_ASSIGN_CHILDREN(infoToShareCHild.parentId);
      const { data } = await this._requestService.Post(path, body);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, a child could not be assigned.');
    }
  }

  async setInviteParent(infoToShareCHild) {
    try {
      const body = this.dataToInviteParent(infoToShareCHild);
      const path = this._paths.INVITE_PARENT(infoToShareCHild.parentId);
      const { data } = await this._requestService.Post(path, body);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, father could not be invited.');
    }
  }

  async setChangeParentTheme({ parentId, themeId }) {
    try {
      const body = {
        themeSelection: themeId,
      };
      const path = this._paths.CHANGE_PARENT_THEME(parentId);
      const { data } = await this._requestService.Post(path, body);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not change theme');
    }
  }

  async setChangeChildTheme({ childId, themeId }) {
    try {
      const body = {
        themeSelection: themeId,
      };
      const path = this._paths.CHANGE_CHILD_THEME(childId);
      const { data } = await this._requestService.Post(path, body);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not change theme');
    }
  }

  async setParentInformation({ parentId, parentInformation }) {
    try {
      const body = {
        name: parentInformation.name,
        last_name: parentInformation.lastName,
      };
      const path = this._paths.UPDATE_PARENT(parentId);
      const { data } = await this._requestService.Patch(path, body);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not update parent information');
    }
  }

  async setChildInformation({ parentId, childId, childformation }) {
    try {
      const body = childformation?.name
        ? {
            child: childId,
            name: childformation.name,
            last_name: childformation.lastName,
          }
        : { child: childId, account_access: childformation.isActive };

      const path = this._paths.UPDATE_CHILD(parentId);
      const { data } = await this._requestService.Patch(path, body);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not update child information');
    }
  }
}
